import { Typography } from '@mui/material';
import * as React from 'react';
import { VerifyError } from '../recoil';
import { FailedMessage } from './FailedMessage';
import { Fit } from './Fit';

interface ErrorBoundaryProps {
  children?: React.ReactNode;
}

type State = {
  error?: Error;
};

export class ErrorBoundary extends React.Component<ErrorBoundaryProps> {
  state: State = {};

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  render() {
    const { error } = this.state;

    return !error ? (
      this.props.children
    ) : error instanceof VerifyError ? (
      <FailedMessage type={error.failType} />
    ) : (
      <Fit>
        <Typography variant="h5">{error.message}</Typography>
      </Fit>
    );
  }
}
